import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { getProfessionalLeagueRanks } from '../redux'

// Component
import MainHeader from '../components/MainHeader'
import PowerRanking from '../components/PowerRanking'
import PlayerRanking from '../components/PlayerRanking'
import RollingNewsFeed from '../components/RollingNewsFeed'
import TransactionTracker from '../components/TransactionTracker'
import Loader from '../components/Loader'
import LeagueStandingsHockey from '../components/LeagueStandingsHockey'

const ProfessionalLeague = () => {
  const SETTING = useSelector((state) => state.user.setting)
  const [ranks, setRanks] = useState(null)
  const [isLoading, setIsloading] = useState(true)

  useEffect(() => {
    getTeamAndPlayerRank()
  }, [SETTING?.date])

  const getTeamAndPlayerRank = async () => {
    setIsloading(true)
    let data = await getProfessionalLeagueRanks(SETTING?.date)
    setRanks(data)
    setIsloading(false)
  }

  return (
    <div className='pro_league_container'>
      <MainHeader />

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className='league_details_container'>
            <div className='left'>
              <LeagueStandingsHockey maxHeight={'875px'} />
            </div>
            <div className='center'>
              <RollingNewsFeed maxHeight={'310px'} />
              <TransactionTracker maxHeight={'343px'} />
            </div>
            <div className='right'>
              <PowerRanking data={ranks?.teamRanks} maxHeight={'400px'} />
              <PlayerRanking data={ranks?.playerRanks} maxHeight={'400px'} />
            </div>
          </section>
        </>
      )}
    </div>
  )
}

export default ProfessionalLeague
